<template>
  <div class="card col-5">
    <div class="card-header">
      <div class="col-2 pull-right">
        <button
          class="btn btn-success p-0 round-button rounded-circle pull-right mr-3 position-absolute"
          style="height: 35px; width: 35px"
          @click="close()"
        >
          <i
            role="button"
            class="fa fa-arrow-left fa-2x"
            aria-hidden="true"
          ></i>
        </button>
      </div>
      <p class="category">DETALLE DE TURNO</p>
      <div class="row card-body py-0">
        <small
          class="my-auto bg-secondary text-light py-1 px-2 rounded font-weight-bold"
          >NOMBRE:</small
        >
        <fg-input
          v-if="editIsEnabled"
          v-model="shiftData.descripcionTurno"
          size="large"
          class="ml-4"
        ></fg-input>
        <p v-else class="mb-0 mt-auto lead ml-4">
          {{ shiftData.descripcionTurno }}
          <span 
            class="badge ml-2" 
            :class="shiftData.activo ? 'badge-success' : 'badge-danger'"
          >
            {{ shiftData.activo ? 'Activo' : 'Inactivo' }}
          </span>
        </p>
        <i
          v-if="editIsEnabled"
          @click="deleteShift"
          class="fa fa-trash fa-2x mr-0 ml-auto text-danger cursor-pointer hover-shadow"
          aria-hidden="true"
        ></i>
      </div>
      <!-- <hr /> -->
    </div>
    <div class="card-body">
      <div class="d-flex flex-row">
        <small class="col-2 mb-3 mt-auto text-nowrap">LUNES</small>
        <div class="col-auto my-auto d-flex flex-column">
          <label class="text-center mx-auto">{{
            shiftData.lunesAutorizado ? "SI" : "NO"
          }}</label>
          <p-switch
            size="small"
            :disabled="!editIsEnabled"
            v-model="shiftData.lunesAutorizado"
            type="success"
          ></p-switch>
        </div>
        <div class="col my-auto">
          <div class="d-flex col justify-content-end">
            <small class="my-auto col-4 text-lowercase">INICIO</small>
            <el-time-select
              class="w-75"
              :disabled="!editIsEnabled"
              v-model="shiftData.lunesHoraInicio"
              format="HH:mm:ss"
              format-value="HH:mm:ss"
              size="small"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
              }"
              placeholder="INICIO"
            >
            </el-time-select>
          </div>
          <div class="d-flex col justify-content-end">
            <small class="my-auto col-4 text-lowercase">FIN</small>
            <el-time-select
              class="w-75"
              :disabled="!editIsEnabled"
              v-model="shiftData.lunesHoraTermino"
              format="HH:mm:ss"
              format-value="HH:mm:ss"
              size="small"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
              }"
              placeholder="FIN"
            >
            </el-time-select>
          </div>
        </div>
      </div>
      <hr class="mx-4 my-2" />
      <div class="d-flex flex-row">
        <small class="col-2 mb-3 mt-auto text-nowrap">MARTES</small>
        <div class="col-auto my-auto d-flex flex-column">
          <label class="text-center mx-auto">{{
            shiftData.martesAutorizado ? "SI" : "NO"
          }}</label>
          <p-switch
            size="small"
            :disabled="!editIsEnabled"
            v-model="shiftData.martesAutorizado"
            type="success"
          ></p-switch>
        </div>
        <div class="col my-auto">
          <div class="d-flex col justify-content-end">
            <small class="my-auto col-4 text-lowercase">INICIO</small>
            <el-time-select
              class="w-75"
              :disabled="!editIsEnabled"
              v-model="shiftData.martesHoraInicio"
              format="HH:mm:ss"
              format-value="HH:mm:ss"
              size="small"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
              }"
              placeholder="INICIO"
            >
            </el-time-select>
          </div>
          <div class="d-flex col justify-content-end">
            <small class="my-auto col-4 text-lowercase">FIN</small>
            <el-time-select
              class="w-75"
              :disabled="!editIsEnabled"
              v-model="shiftData.martesHoraTermino"
              format="HH:mm:ss"
              format-value="HH:mm:ss"
              size="small"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
              }"
              placeholder="FIN"
            >
            </el-time-select>
          </div>
        </div>
      </div>
      <hr class="mx-4 my-2" />
      <div class="d-flex flex-row">
        <small class="col-2 mb-3 mt-auto text-nowrap">MIERCOLES</small>
        <div class="col-auto my-auto d-flex flex-column">
          <label class="text-center mx-auto">{{
            shiftData.miercolesAutorizado ? "SI" : "NO"
          }}</label>
          <p-switch
            size="small"
            :disabled="!editIsEnabled"
            v-model="shiftData.miercolesAutorizado"
            type="success"
          ></p-switch>
        </div>
        <div class="col my-auto">
          <div class="d-flex col justify-content-end">
            <small class="my-auto col-4 text-lowercase">INICIO</small>
            <el-time-select
              class="w-75"
              :disabled="!editIsEnabled"
              v-model="shiftData.miercolesHoraInicio"
              format="HH:mm:ss"
              format-value="HH:mm:ss"
              size="small"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
              }"
              placeholder="INICIO"
            >
            </el-time-select>
          </div>
          <div class="d-flex col justify-content-end">
            <small class="my-auto col-4 text-lowercase">FIN</small>
            <el-time-select
              class="w-75"
              :disabled="!editIsEnabled"
              v-model="shiftData.miercolesHoraTermino"
              format="HH:mm:ss"
              format-value="HH:mm:ss"
              size="small"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
              }"
              placeholder="FIN"
            >
            </el-time-select>
          </div>
        </div>
      </div>
      <hr class="mx-4 my-2" />
      <div class="d-flex flex-row">
        <small class="col-2 mb-3 mt-auto text-nowrap">JUEVES</small>
        <div class="col-auto my-auto d-flex flex-column">
          <label class="text-center mx-auto">{{
            shiftData.juevesAutorizado ? "SI" : "NO"
          }}</label>
          <p-switch
            size="small"
            :disabled="!editIsEnabled"
            v-model="shiftData.juevesAutorizado"
            type="success"
          ></p-switch>
        </div>
        <div class="col my-auto">
          <div class="d-flex col justify-content-end">
            <small class="my-auto col-4 text-lowercase">INICIO</small>
            <el-time-select
              class="w-75"
              :disabled="!editIsEnabled"
              v-model="shiftData.juevesHoraInicio"
              format="HH:mm:ss"
              format-value="HH:mm:ss"
              size="small"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
              }"
              placeholder="INICIO"
            >
            </el-time-select>
          </div>
          <div class="d-flex col justify-content-end">
            <small class="my-auto col-4 text-lowercase">FIN</small>
            <el-time-select
              class="w-75"
              :disabled="!editIsEnabled"
              v-model="shiftData.juevesHoraTermino"
              format="HH:mm:ss"
              format-value="HH:mm:ss"
              size="small"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
              }"
              placeholder="FIN"
            >
            </el-time-select>
          </div>
        </div>
      </div>
      <hr class="mx-4 my-2" />
      <div class="d-flex flex-row">
        <small class="col-2 mb-3 mt-auto text-nowrap">VIERNES</small>
        <div class="col-auto my-auto d-flex flex-column">
          <label class="text-center mx-auto">{{
            shiftData.viernesAutorizado ? "SI" : "NO"
          }}</label>
          <p-switch
            size="small"
            :disabled="!editIsEnabled"
            v-model="shiftData.viernesAutorizado"
            type="success"
          ></p-switch>
        </div>
        <div class="col my-auto">
          <div class="d-flex col justify-content-end">
            <small class="my-auto col-4 text-lowercase">INICIO</small>
            <el-time-select
              class="w-75"
              :disabled="!editIsEnabled"
              v-model="shiftData.viernesHoraInicio"
              format="HH:mm:ss"
              format-value="HH:mm:ss"
              size="small"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
              }"
              placeholder="INICIO"
            >
            </el-time-select>
          </div>
          <div class="d-flex col justify-content-end">
            <small class="my-auto col-4 text-lowercase">FIN</small>
            <el-time-select
              class="w-75"
              :disabled="!editIsEnabled"
              v-model="shiftData.viernesHoraTermino"
              format="HH:mm:ss"
              format-value="HH:mm:ss"
              size="small"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
              }"
              placeholder="FIN"
            >
            </el-time-select>
          </div>
        </div>
      </div>
      <hr class="mx-4 my-2" />
      <div class="d-flex flex-row">
        <small class="col-2 mb-3 mt-auto text-nowrap">SABADO</small>
        <div class="col-auto my-auto d-flex flex-column">
          <label class="text-center mx-auto">{{
            shiftData.sabadoAutorizado ? "SI" : "NO"
          }}</label>
          <p-switch
            size="small"
            :disabled="!editIsEnabled"
            v-model="shiftData.sabadoAutorizado"
            type="success"
          ></p-switch>
        </div>
        <div class="col my-auto">
          <div class="d-flex col justify-content-end">
            <small class="my-auto col-4 text-lowercase">INICIO</small>
            <el-time-select
              class="w-75"
              :disabled="!editIsEnabled"
              v-model="shiftData.sabadoHoraInicio"
              format="HH:mm:ss"
              format-value="HH:mm:ss"
              size="small"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
              }"
              placeholder="INICIO"
            >
            </el-time-select>
          </div>
          <div class="d-flex col justify-content-end">
            <small class="my-auto col-4 text-lowercase">FIN</small>
            <el-time-select
              class="w-75"
              :disabled="!editIsEnabled"
              v-model="shiftData.sabadoHoraTermino"
              format="HH:mm:ss"
              format-value="HH:mm:ss"
              size="small"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
              }"
              placeholder="FIN"
            >
            </el-time-select>
          </div>
        </div>
      </div>
      <hr class="mx-4 my-2" />
      <div class="d-flex flex-row">
        <small class="col-2 mb-3 mt-auto text-nowrap">DOMINGO</small>
        <div class="col-auto my-auto d-flex flex-column">
          <label class="text-center mx-auto">{{
            shiftData.domingoAutorizado ? "SI" : "NO"
          }}</label>
          <p-switch
            size="small"
            :disabled="!editIsEnabled"
            v-model="shiftData.domingoAutorizado"
            type="success"
          ></p-switch>
        </div>
        <div class="col my-auto">
          <div class="d-flex col justify-content-end">
            <small class="my-auto col-4 text-lowercase">INICIO</small>
            <el-time-select
              class="w-75"
              :disabled="!editIsEnabled"
              v-model="shiftData.domingoHoraInicio"
              format="HH:mm:ss"
              format-value="HH:mm:ss"
              size="small"
              :picker-options="{
                start: '00:00',
                step: '00:01',
                end: '23:59',
              }"
              placeholder="INICIO"
            >
            </el-time-select>
          </div>
          <div class="d-flex col justify-content-end">
            <small class="my-auto col-4 text-lowercase">FIN</small>
            <el-time-select
              class="w-75"
              :disabled="!editIsEnabled"
              v-model="shiftData.domingoHoraTermino"
              format="HH:mm:ss"
              format-value="HH:mm:ss"
              size="small"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
              }"
              placeholder="FIN"
            >
            </el-time-select>
          </div>
        </div>
      </div>
      <hr class="mx-4 my-2" />
    </div>
    <div class="card-footer d-flex flex-row justify-content-center">
      <template v-if="editIsEnabled">
        <button
          class="btn btn-success w-auto mr-3"
          @click="saveChanges"
          :disabled="shiftDataHasChanged"
        >
          GUARDAR
        </button>
        <button class="btn btn-danger w-auto" @click="disableEdit">
          CANCELAR
        </button>
      </template>
      <button v-else @click="enableEdit" class="btn btn-info w-auto">
        EDITAR
      </button>
    </div>
  </div>
</template>

<script>
import PSwitch from "src/components/UIComponents/Switch.vue";
import { TimeSelect } from "element-ui";
import _ from "lodash";
export default {
  components: {
    PSwitch,
    [TimeSelect.name]: TimeSelect,
  },
  name: "shiftDetails",
  props: {
    enableEditProp: {
      type: Boolean,
      default: false,
    },
    shiftData: {
      type: Object,
      default: () => ({
        _id: "mockId",
        id: 0,
        nombreEmpresa: "2Tec Sistemas Spa",
        lunesAutorizado: true,
        martesAutorizado: true,
        miercolesAutorizado: true,
        juevesAutorizado: true,
        viernesAutorizado: true,
        sabadoAutorizado: true,
        domingoAutorizado: true,
        descripcionTurno: "TURNO DEFAULT",
        lunesHoraInicio: "09:30:00",
        lunesHoraTermino: "19:00:00",
        martesHoraInicio: "09:30:00",
        martesHoraTermino: "19:00:00",
        miercolesHoraInicio: "09:30:00",
        miercolesHoraTermino: "19:00:00",
        juevesHoraInicio: "09:30:00",
        juevesHoraTermino: "19:00:00",
        viernesHoraInicio: "09:30:00",
        viernesHoraTermino: "19:00:00",
        sabadoHoraInicio: "09:30:00",
        sabadoHoraTermino: "19:00:00",
        domingoHoraInicio: "09:30:00",
        domingoHoraTermino: "19:00:00",
        activo: true,
      }),
    },
  },
  watch: {
    enableEditProp: function (newValue, oldValue) {
      if (!newValue) {
        this.editIsEnabled = false;
      }
    },
    // shiftData: function (newValue) {
    //   this.$logger.log("detalles");
    //   this.$logger.log(newValue);
    // },
  },
  data() {
    return {
      editIsEnabled: false,
      shiftOG: {},
    };
  },
  computed: {
    shiftDataHasChanged() {
      var changes = 0;
      if (this.shiftOG) {
        const keys = Object.keys(this.shiftOG);
        keys.forEach((key) => {
          if (this.shiftOG[key] != this.shiftData[key]) {
            changes++;
          }
        });
      }
      return !changes;
    },
  },
  methods: {
    editSuccess() {
      this.shiftOG = _.cloneDeep(this.shiftData);
      this.editIsEnabled = false;
    },
    saveChanges() {
      this.$emit("saveChanges");
    },
    enableEdit() {
      this.shiftOG = _.cloneDeep(this.shiftData);
      // this.$logger.log(this.shiftData);
      this.editIsEnabled = true;
    },
    disableEdit() {
      this.$emit("restoreOriginalShiftData", this.shiftOG);
      this.editIsEnabled = false;
    },
    deleteShift() {
      // Verificar si es eliminación lógica (desactivar) o física (eliminar permanentemente)
      const isLogicalDelete = this.shiftData.activo;
      
      const confirmOptions = isLogicalDelete ? {
        title: '¿Desactivar turno?',
        text: `El turno "${this.shiftData.descripcionTurno}" será desactivado. Podrás reactivarlo más tarde o eliminarlo permanentemente.`,
        icon: 'warning',
        confirmButtonText: 'Sí, desactivar',
        confirmButtonColor: '#f5a623',
        cancelButtonText: 'Cancelar',
        showCancelButton: true
      } : {
        title: '¿Eliminar permanentemente?',
        text: `¡ATENCIÓN! El turno "${this.shiftData.descripcionTurno}" será eliminado permanentemente. Esta acción NO se puede deshacer.`,
        icon: 'error',
        confirmButtonText: 'Sí, eliminar permanentemente',
        confirmButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        showCancelButton: true
      };
      
      this.$swal.fire(confirmOptions).then((result) => {
        if (result.isConfirmed) {
          // Emitir evento con información sobre el tipo de eliminación
          this.$emit("deleteShift", {
            id: this.shiftData.id,
            isLogicalDelete: isLogicalDelete,
            shiftName: this.shiftData.descripcionTurno
          });
        }
      });
    },
    close() {
      this.editIsEnabled = false;
      this.$emit("closingShiftsDetails");
    },
  },
};
</script>

<style>
.cursor-pointer:hover {
  cursor: pointer;
}
.hover-shadow:hover {
  text-shadow: 2px 2px 4px #343a409a;
}
</style>
